/* export const UrlPublic = 'https://www.iudlm.com.ve/'; */

/* export const UrlPublic = 'https://sistema.iudlm.com.ve/'; */

/* export const UrlPublic = 'http://localhost/tad_backend/public/'; */

export const UrlPublic = 'https://pruebas.edueyss.com/';

/* export const UrlPublic = 'http://192.168.1.51/'; */




// WEBPACK FOOTER //
// ./src/shared/UrlPublic.jsx